/**
 * Created by lu on 2018/4/10.
 */
var nb = require('../../../../nb');
module.exports = nb.define({
    view: {
        tag:'li',
        'class': 'brand-item',
        $html: [{
            tag:'a',
            href:nb.bind('href'),
            target:'_blank',
            'class':'logo-image',
            $html:{
                tag:'img',
                'class':'grayscale abs-center',
                alt:nb.bind('name'),
                src:nb.bind('imgUrl')
            }
        }]
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/view/brand/BrandItem.js
// module id = 536
// module chunks = 6